import { useFlags } from "launchdarkly-react-client-sdk";

import { INTAKE_PHYSICIAN_REVIEW_QUEUE_FEATURE } from "constants/feature-flags";
import {
  PHYSICIAN_PICKER_QUERY,
  PHYSICIAN_PICKER_QUERY_WITH_REVIEW
} from "constants/physicians";

/**
 * The picker projection (ENG-2221), plus `intake_review_pending` when the review queue is on, which
 * is what `useNeedsReviewOptionLabel` reads to mark a pending physician (SN-19728).
 *
 * Flag off => the plain picker query, so the request URL is byte-identical to before.
 */
export default function usePhysicianPickerQuery() {
  const flags = useFlags();
  return flags[INTAKE_PHYSICIAN_REVIEW_QUEUE_FEATURE]
    ? PHYSICIAN_PICKER_QUERY_WITH_REVIEW
    : PHYSICIAN_PICKER_QUERY;
}
